import { FormEvent, useState } from "react";
import { supabase } from "@/lib/supabaseClient";
import { useNavigate } from "react-router-dom";
import Button from "./ui/AppButton";

export default function CaseForm() {
  const navigate = useNavigate();
  const [form, setForm] = useState<Record<string, string | number | null>>({ title: "" });
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  function update(name: string, value: string) {
    setForm((f) => ({ ...f, [name]: value }));
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (!String(form.title || "").trim()) return setMessage("Le titre est requis");
    setSubmitting(true);
    setMessage(null);
    const { error } = await supabase.from("cases").insert({
      title: form.title,
      company_name: form.company_name || null,
      client_first_name: form.client_first_name || null,
      client_last_name: form.client_last_name || null,
      client_email: form.client_email || null,
      center: form.center || null,
      activity_type: form.activity_type || null,
      pax: form.pax ? Number(form.pax) : null,
      event_date: form.event_date || null,
      budget: form.budget ? Number(form.budget) : null,
      source: form.source || null
    });
    setSubmitting(false);
    if (error) {
      setMessage(error.message);
    } else {
      setMessage("Dossier créé");
      navigate("/cases");
    }
  }

  return (
    <div className="container py-8">
      <h1 className="text-xl font-semibold mb-4">Créer un dossier</h1>
      <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[
          ["title", "Titre"],
          ["company_name", "Entreprise"],
          ["client_first_name", "Prénom client"],
          ["client_last_name", "Nom client"],
          ["client_email", "Email client"],
          ["center", "Centre"],
          ["activity_type", "Type d’activité"],
          ["pax", "Participants"],
          ["event_date", "Date de l’évènement"],
          ["budget", "Budget"],
          ["source", "Source"],
        ].map(([key, label]) => (
          <label key={key} className="flex flex-col gap-1">
            <span className="text-sm text-muted-foreground">{label}</span>
            <input
              className="border rounded-md px-3 py-2"
              value={String(form[key] ?? "")}
              onChange={(e) => update(key, e.target.value)}
            />
          </label>
        ))}
        <div className="md:col-span-2 flex items-center gap-4">
          <Button disabled={submitting} type="submit">Créer</Button>
          {message && <div className="text-sm text-muted-foreground">{message}</div>}
        </div>
      </form>
    </div>
  );
}


